<template>
  <MglMarker :coordinates="coordinates" anchor="center">
    <div slot="marker">
      <StatusDot
        class="marker"
        fillColor="#f19938"
        :size="32"
        :strokeWidth="5"
      />
    </div>
  </MglMarker>
</template>

<script>
import StatusDot from '@/components/status-dot';
import { MglMarker } from 'vue-mapbox';

export default {
  components: {
    MglMarker,
    StatusDot,
  },
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
  },
};
</script>
